import { ParsedUrlQueryInput } from 'querystring';

import { ListingSearchRoomInterface } from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { HotelTypes } from '@domain/hotel/hotelAutoComplate';
import { DateDataTypes } from '@domain/hotel/searchBar/dateSelection';

export interface IHotelSearchBarState {
  location: HotelTypes | null;
  isLocationError: boolean;
  rooms: ListingSearchRoomInterface[];
  checkDates: DateDataTypes | null;
  isCheckDatesError: boolean;
  isDrawerOpen: boolean;
  isHotelDateSelected: boolean;
  allResultsURL?: {
    query: string | ParsedUrlQueryInput | null | undefined;
    pathname: string;
  };
}

export enum HotelSearchBarActionType {
  SET_LOCATION = 'SetHotelLocation',
  SET_IS_LOCATION_ERROR = 'SetHotelIsLocationError',
  SET_ROOMS = 'SetHotelRooms',
  SET_CHECK_DATES = 'SetHotelCheckDates',
  SET_IS_CHECK_DATES_ERROR = 'SetHotelIsCheckDatesError',
  SET_ALL = 'SetHotelAll',
  SET_IS_DRAWER_OPEN = 'SetHotelIsDrawerOpen',
  SET_IS_HOTEL_DATE_SELECTED = 'SetHotelIsDateSelected',
  SET_ALL_RESULTS_URL = 'SetHotelAllResultsUrl',
}

export interface SetLocation {
  type: HotelSearchBarActionType.SET_LOCATION;
  payload: IHotelSearchBarState['location'];
}

export interface SetIsLocationError {
  type: HotelSearchBarActionType.SET_IS_LOCATION_ERROR;
  payload: IHotelSearchBarState['isLocationError'];
}
export interface SetRooms {
  type: HotelSearchBarActionType.SET_ROOMS;
  payload: IHotelSearchBarState['rooms'];
}

export interface SetCheckDates {
  type: HotelSearchBarActionType.SET_CHECK_DATES;
  payload: IHotelSearchBarState['checkDates'];
}

export interface SetIsCheckDatesError {
  type: HotelSearchBarActionType.SET_IS_CHECK_DATES_ERROR;
  payload: IHotelSearchBarState['isCheckDatesError'];
}

export interface SetHotelAll {
  type: HotelSearchBarActionType.SET_ALL;
  payload: IHotelSearchBarState;
}

export interface SetIsDrawerOpen {
  type: HotelSearchBarActionType.SET_IS_DRAWER_OPEN;
  payload: IHotelSearchBarState['isDrawerOpen'];
}

export interface SetIsHotelDateSelected {
  type: HotelSearchBarActionType.SET_IS_HOTEL_DATE_SELECTED;
  payload: IHotelSearchBarState['isHotelDateSelected'];
}

export interface SetHotelAllResultsUrl {
  type: HotelSearchBarActionType.SET_ALL_RESULTS_URL;
  payload: IHotelSearchBarState['allResultsURL'];
}

export type HotelSearchBarActions =
  | SetLocation
  | SetIsLocationError
  | SetRooms
  | SetCheckDates
  | SetIsCheckDatesError
  | SetHotelAll
  | SetIsDrawerOpen
  | SetIsHotelDateSelected
  | SetHotelAllResultsUrl;
